import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { PrintableReport, ReportPrintRequest } from './report-print.model';

@Injectable({ providedIn: 'root' })
export class ReportPrintService {
  private readonly reportSubject = new BehaviorSubject<PrintableReport | null>(null);
  public readonly report$ = this.reportSubject.asObservable();

  public print(request: ReportPrintRequest): void {
    this.reportSubject.next({
      ...request,
      // Object.entries preserves the insertion order used by each dashboard report producer.
      legend: Object.entries(request.legend).map(([heading, value]) => ({ heading, value })),
    });
  }

  public close(): void {
    this.reportSubject.next(null);
  }
}
